export default __webpack_public_path__ + "dummy-portrait.png";